<!-- 修改密码 -->
<template>
  <section>
    <div class="personal-center-form__section">
      <h1 class="personal-center-form__title">修改密码</h1>
      <div class="personal-center-form__main">
        <el-row :gutter="0" class="personal-center-form__form">
          <el-col :span="16">
            <el-form label-width="50%" :model="updatePasswordFormModel" :rules="rules" ref="updatePasswordForm">
              <el-form-item label="旧密码"  prop="oldPassword">
                <el-input type="password" placeholder="请输入旧密码" v-model="updatePasswordFormModel.oldPassword" @blur="inputBlurFn('oldPassword')" :maxlength="16"></el-input>
              </el-form-item>
              <el-form-item label="新密码" prop="newPassword">
                <el-input type="password" placeholder="请输入新密码" v-model="updatePasswordFormModel.newPassword" @blur="inputBlurFn('newPassword')" :maxlength="16"></el-input>
              </el-form-item>
              <el-form-item label="确认新密码"  prop="confirmPassword">
                <el-input type="password" placeholder="请再输入一次新密码" v-model="updatePasswordFormModel.confirmPassword" @blur="inputBlurFn('confirmPassword')" :maxlength="16"></el-input>
              </el-form-item>
              <el-form-item label="图形验证码" prop="verificationCode" class="update-password__verification-code">
                <el-input placeholder="请输入图形验证码" :maxlength="4" v-model="updatePasswordFormModel.verificationCode" @blur="inputBlurFn('verificationCode')"></el-input>
                <img class="verification-img" :src="verificationImageSrc" alt="verification code" ref="verificationCode" v-show="verificationImageSrc"
                     @click="refreshVerificationCode">
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <div class="text-center">
          <el-button type="primary" style="background:#EB662B;" :loading="isLoading" class="personal-center-form__submit" @click="submitForm">
            提交
          </el-button>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
  import placeholders from '../../scripts/placeholders';
  import { mapGetters, mapActions } from 'vuex';
  import * as types from '../../vuex/types/type';

  export default {
    data () {
      const assignValidator = (type, trigger = 'blur') => Object.assign({
        required: true,
        trigger
      }, {
        validator: (rules, value, callback, source, options) => {
          this.$store.dispatch(type, {rules, value, callback, source, options});
        }
      });
      return {
        isLoading: false,
        publicKey: '',
        verificationImageSrc: '',
        rules: {
          oldPassword: [assignValidator((types.VERIFY_PASSWORD_VALID))],
          newPassword: [assignValidator(types.VERIFY_REGISTER_PASSWORD)],
          confirmPassword: [{
            required: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (value === '') {
                callback(new Error('请再次输入密码'));
              } else if (value !== this.updatePasswordFormModel.newPassword) {
                callback(new Error('两次输入密码不一致'));
              } else {
                callback();
              }
            }
          }],
          verificationCode: [{
            required: true,
            trigger: 'blur',
            validator: (rules, value, callback, source, options) => {
              this.$store.dispatch(types.VERIFY_LOGIN_VERIFICATION_CODE, {rules, value, callback, source, options}).then((res) => {
                if (res) {
                  if (Number(res.data.code) === 1) {
                    this.refreshVerificationCode();
                  }
                } else {
                  this.refreshVerificationCode();
                }
              });
            }
          }]
        },
        updatePasswordFormModel: {
          oldPassword: '',
          newPassword: '',
          confirmPassword: '',
          verificationCode: ''
        }
      };
    },
    computed: {
      ...mapGetters({
        ajaxBaseUrl: types.GET_AJAX_BASE_URL,
        userInfo: types.GET_USER
      })
    },
    methods: {
      ...mapActions({
        updatePassword: types.UPDATE_PASSWORD,
        setSuccessMessage: types.SET_SUCCESS_MESSAGE,
        getGenerateRSAPublicKey: types.GET_GENERATE_RSA_PUBLIC_KEY
      }),
      refreshVerificationCode () {
        this.verificationImageSrc = `${this.ajaxBaseUrl}/servlet/ValidCode?rand=${new Date().getTime()}`;
      },
      submitForm () {
        const _this = this;
        _this.loading = true;
        _this.$refs.updatePasswordForm.validate((valid) => {
          if (valid) {
            const form = this.updatePasswordFormModel;
            const encrypt = new JSEncrypt();
            encrypt.setPublicKey(this.publicKey);
            const _oldPassword = encodeURI(encrypt.encrypt(form.oldPassword));
            const _newPassword = encodeURI(encrypt.encrypt(form.newPassword));

            _this.updatePassword({
              router: _this.$router,
              token: _this.userInfo.token,
              oldPwd: _oldPassword,
              newPwd: _newPassword
            }).then((res) => {
              _this.loading = false;
              if (Number(res.data.code) === 0) {
                _this.setSuccessMessage({
                  show: true,
                  content: '密码修改成功'
                });
                _this.updatePasswordFormModel.oldPassword = '';
                _this.updatePasswordFormModel.newPassword = '';
                _this.updatePasswordFormModel.confirmPassword = '';
                _this.updatePasswordFormModel.verificationCode = '';
                _this.refreshVerificationCode();
              }
              setTimeout(() => {
                _this.refreshVerificationCode();
              }, 30);
            });
          } else {
            setTimeout(() => {
              placeholders.placeHolder(this);
            }, 30);
            return false;
          }
        });
      },
      inputBlurFn (prop) {
        if (event.srcElement) {
          this.updatePasswordFormModel[prop] = event.srcElement.value;
        }
      }
    },
    mounted () {
      this.refreshVerificationCode();
      this.getGenerateRSAPublicKey().then((res) => {
        this.publicKey = res.data.publicKey;
      });
    }
  };
</script>
<style lang="scss">
  .update-password__verification-code img {
    position: absolute;
    top: 8px;
    right: 8px !important;
  }
</style>



// WEBPACK FOOTER //
// UpdatePassword.vue?bf580ed6